/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { getArchivedPages } from 'catalog/reducers/pages';
import * as PagesActions from 'catalog/actions/pages';
import ArchivesList from './components/ArchiveList';

type Props = {
  archives: List<CatalogPage>,
  unarchive: (page: CatalogPage) => void,
};

const mapStateToProps = state => ({
  archives: getArchivedPages(state),
});

const Archives = ({ archives, unarchive }: Props) => (
  <ArchivesList archives={archives} onUnarchive={unarchive} />
);

export default connect(mapStateToProps, {
  unarchive: PagesActions.unarchivePage,
})(Archives);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Archives/index.js